export { default as LandingPageHead } from './landing-page-head';
export { default as SearchResultsHead } from './search-result-head';
